import { sleep } from "src/domains/screens/helpers/actions";

/**
 * Polls a remote image URL until it loads successfully or the attempt limit is reached.
 *
 * Workaround until firebase realtime status updates are in place.
 * Maximum wait: 15 attempts × 2 s = 30 s.
 */
export const pollForImage = async (url: string): Promise<boolean> => {
  const maxAttempts = 15;
  const intervalMs = 2000;

  const loadImage = (src: string): Promise<boolean> => {
    return new Promise((resolve) => {
      const image = new Image();
      image.onload = () => resolve(true);
      image.onerror = () => resolve(false);
      image.src = src;
    });
  };

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const isAvailable = await loadImage(url);
      if (isAvailable) {
        console.log("Image is available! Render it.");
        return true;
      }
      if (attempt === maxAttempts) {
        console.log(
          "Image not available after maximum attempts. Stop polling.",
        );
        return false;
      }
      await sleep(intervalMs);
      console.log(`Attempt ${attempt}: Image not available. Polling again...`);
    } catch (error) {
      console.log("Error while polling:", error);
    }
  }

  return false;
};
